// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1KpNy","disabled":"FileBtn_disabled__dziVo","warn":"FileBtn_warn__2SuXh","fade":"FileBtn_fade__3TxDX"};